import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/psf/promoteOrShare/pageContext';

export function PsfPromoteOrShareErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PsfPromoteOrShare page (error: ${error})`);
}
